import firebase from "firebase/app"
import "firebase/firestore"

if (!firebase.apps.length) {
  const firebaseConfig = {
    apiKey: "AIzaSyD2ivBk_st7ygf3QU6NRszGWXl-9dPTLvM",
    authDomain: "wdsgames-30962.firebaseapp.com",
    databaseURL: "https://wdsgames-30962.firebaseio.com",
    projectId: "wdsgames-30962",
    storageBucket: "wdsgames-30962.appspot.com",
    messagingSenderId: "57100810497",
    appId: "1:57100810497:web:3b53db2fc0389470f80300",
    measurementId: "G-8LS2PFECZV",
  }

  firebase.initializeApp(firebaseConfig)
}

export const firestore = firebase.firestore
export const sessions = firestore().collection("sessions")
export const users = firestore().collection("users")
